/* eslint-disable no-debugger */
import React, { Component } from 'react';

import { Container, Typography, Box } from '@mui/material';
// import moment from 'moment';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder';
import { connect } from 'react-redux';
import { Breadcrumbs } from 'wae_rwlb_reactlibrary';

import { getBillingTableData, getAllBillingData } from '../../../actions';
import { Table } from '../../../components';
import { COLOR } from '../../../helpers/colors';
import { breadcrumbNameMap } from '../../../helpers/config';
import { formatAmount } from '../../../helpers/functions';
import i18n from '../../../helpers/i18nMain';
import BillingPlaceholder from '../BillingPlaceholder';

const billingColumnsConfig = t => [
  {
    field: 'col1',
    headerName: t('billingScreenTranslations:ID'),
    key: 'BillingDocument',
    minWidth: 150,
    inputType: 'TextField',
  },
  {
    field: 'col2',
    headerName: t('billingScreenTranslations:STATUS'),
    key: 'OverallBillingStatusDesc',
    minWidth: 150,
    flex: 1,
    inputType: 'TextField',
  },
  {
    field: 'col3',
    headerName: t('billingScreenTranslations:SHIP_TO_PARTY'),
    key: 'CustomerName',
    minWidth: 150,
    flex: 1,
    inputType: 'TextField',
  },
  {
    field: 'col4',
    headerName: t('billingScreenTranslations:NET_AMOUNT'),
    key: 'TotalNetAmount',
    minWidth: 150,
    flex: 1,
    inputType: 'Float',
    renderCell: params => {
      return (
        <Typography>
          {formatAmount('en-AE', params.value, params.getValue(params.id, 'col8'))}
        </Typography>
      );
    },
  },
  {
    field: 'col5',
    headerName: t('billingScreenTranslations:TAX_AMOUNT'),
    key: 'TotalTaxAmount',
    minWidth: 150,
    flex: 1,
    inputType: 'Float',
    renderCell: params1 => {
      return (
        <Typography>
          {formatAmount('en-AE', params1.value, params1.getValue(params1.id, 'col8'))}
        </Typography>
      );
    },
  },
  {
    field: 'col6',
    headerName: t('billingScreenTranslations:TOTAL_AMOUNT'),
    key: 'TotalAmount',
    minWidth: 150,
    flex: 1,
    inputType: 'Float',
    renderCell: params2 => {
      return (
        <Typography>
          {formatAmount('en-AE', params2.value, params2.getValue(params2.id, 'col8'))}
        </Typography>
      );
    },
  },
  {
    field: 'col7',
    headerName: t('billingScreenTranslations:INVOICE_DATE'),
    key: 'BillingDocumentDate',
    minWidth: 150,
    flex: 1,
    inputType: 'Date',
  },
  {
    field: 'col8',
    headerName: t('billingScreenTranslations:CURR'),
    key: 'TransactionCurrency',
    minWidth: 150,
    flex: 1,
    hideFromHeader: true,
    hideFromFilter: true,
    inputType: 'TextField',
  },
];
class Billing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 20,
      filteredData: [],
      showPriceFilter: false,
      isLoading: false,
    };
  }

  async componentDidMount() {
    try {
      const { page, rowsPerPage } = this.state;
      const skip = page;
      const top = rowsPerPage;
      await this.props.getBillingTableData(skip, top, this.props.enqueueSnackbar);
    } catch (err) {
      console.log(err);
    }
  }

  handleChange = async (e, value) => {
    try {
      const { rowsPerPage, searchTerm, showDateFilter, filterField, showPriceFilter } = this.state;
      const { t } = this.props;
      const skip = value * rowsPerPage;
      this.setState({ page: value });
      const columnsConfigData = billingColumnsConfig(t);
      const selectedCol = columnsConfigData.find(c => c.field === filterField);
      let filterStr = '';
      if (searchTerm !== '' && selectedCol !== undefined) {
        filterStr =
          showDateFilter || showPriceFilter
            ? `${selectedCol.key} eq ${searchTerm}`
            : `${selectedCol.key} eq '${searchTerm}' or substringof('${searchTerm}', ${selectedCol.key}) eq true`;
      }
      if (filterStr !== '') {
        await this.props.getBillingTableData(
          skip,
          rowsPerPage,
          this.props.enqueueSnackbar,
          filterStr
        );
      } else {
        await this.props.getBillingTableData(skip, rowsPerPage, this.props.enqueueSnackbar);
      }
      window.scrollTo(0, 0);
    } catch (err) {
      console.log(err);
    }
  };

  saveFilterData = async (fData, selectedCol, searchTerm = '') => {
    const { rowsPerPage, showDateFilter, showPriceFilter } = this.state;
    let filterStr = '';
    if (searchTerm !== '') {
      filterStr =
        showDateFilter || showPriceFilter
          ? `${selectedCol.key} eq ${searchTerm}`
          : `${selectedCol.key} eq '${searchTerm}' or substringof('${searchTerm}', ${selectedCol.key}) eq true`;
    }
    if (filterStr !== '') {
      this.props.getBillingTableData(0, rowsPerPage, this.props.enqueueSnackbar, filterStr);
      this.setState({ page: 0 });
    }
    this.setState({ filteredData: fData });
  };

  loadBillingsData = async () => {
    this.setState({ isLoading: true });
    await this.props.getAllBillingData(0, this.props.enqueueSnackbar);
    this.setState({ isLoading: false });
  };

  clearFilter = () => {
    const { rowsPerPage } = this.state;
    this.props.getBillingTableData(0, rowsPerPage, this.props.enqueueSnackbar);
    this.setState({
      searchTerm: '',
      filterField: '',
      selectedDate: null,
      showDateFilter: false,
      page: 0,
    });
  };

  saveFilterFields = data => {
    this.setState(prevState => ({
      ...prevState,
      ...data,
    }));
  };

  renderbilling = () => {
    const {
      rowsPerPage,
      filteredData,
      filterField,
      searchTerm,
      selectedDate,
      showDateFilter,
      isLoading,
    } = this.state;
    const { billing, t } = this.props;
    const { billingDataArr, listCount, failText } = billing;
    if (billingDataArr) {
      return (
        <Table
          columnsConfig={billingColumnsConfig(t)}
          data={billingDataArr}
          language={i18n.language}
          showExport
          rowsPerPage={rowsPerPage}
          listCount={listCount}
          page={this.state.page}
          onPageChange={this.handleChange}
          filteredData={filteredData}
          saveFilterData={this.saveFilterData}
          loadFullData={this.loadBillingsData}
          filterField={filterField}
          searchTerm={searchTerm}
          selectedDate={selectedDate}
          saveFilterFields={this.saveFilterFields}
          clearFilter={this.clearFilter}
          showDateFilter={showDateFilter}
          t={t}
          isLoading={isLoading}
        />
      );
    }
    if (failText !== '') {
      return (
        <Typography sx={{ m: 4, fontSize: 36, color: COLOR.helperTextColor }} textAlign="center">
          {failText}
        </Typography>
      );
    }
    return (
      <Typography
        sx={{
          m: 4,
          fontSize: 36,
          color: COLOR.helperTextColor,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
        textAlign="center"
      >
        {this.props.t('billingScreenTranslations:NO_BILLING_DATA_FOUND')}
      </Typography>
    );
  };

  render() {
    const { billing, t } = this.props;
    const { isLoading } = billing;
    return (
      <Container>
        <Breadcrumbs {...this.props} breadcrumbNameMap={breadcrumbNameMap(t)} />
        <ReactPlaceholder
          showLoadingAnimation
          ready={!isLoading}
          customPlaceholder={<BillingPlaceholder />}
        >
          <Box sx={{ marginY: 6 }}>{this.renderbilling()}</Box>
        </ReactPlaceholder>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    billing: state.billing,
  };
};
const cBilling = connect(mapStateToProps, { getBillingTableData, getAllBillingData })(Billing);
const tBilling = withTranslation(['billingScreenTranslations'])(cBilling);
const sBilling = withSnackbar(tBilling);
export { sBilling as Billing };
